import React from "react"
import { Card, CardBody, Badge } from "reactstrap"
import SectionHeader from "components/Common/SectionHeader"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
import { formatReadableDate } from "utils/formatDate"

// Helper function to check if value exists
const hasValue = (value) => {
  if (value === null || value === undefined) return false
  if (typeof value === "string" && value.trim() === "") return false
  return true
}

const AdditionalInfoCard = ({ importer, loading }) => {
  const infoItems = [
    {
      label: "ID",
      value: importer?.id ? `#${importer.id}` : null,
      hasValue: hasValue(importer?.id),
    },
    {
      label: "Created At",
      value: importer?.created_at ? formatReadableDate(importer.created_at) : null,
      hasValue: hasValue(importer?.created_at),
    },
    {
      label: "Updated At",
      value: importer?.updated_at ? formatReadableDate(importer.updated_at) : null,
      hasValue: hasValue(importer?.updated_at),
    },
    {
      label: "Deleted At",
      value: importer?.deleted_at ? formatReadableDate(importer.deleted_at) : null,
      hasValue: hasValue(importer?.deleted_at),
      badgeColor: "danger",
    },
  ]

  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-3">
        <SectionHeader
          icon="bx bx-info-circle"
          title="Additional Information"
        />
        <div className="specs-list">
          {loading ? (
            Array(4).fill().map((_, index) => (
              <div key={index} className="d-flex justify-content-between py-2 border-bottom">
                <span className="text-muted">Loading...</span>
                <ThemePlaceholder style={{ width: 150, height: 20, borderRadius: 4 }} />
              </div>
            ))
          ) : (
            infoItems.map((item, index) => (
              <div key={index} className="d-flex justify-content-between py-2 border-bottom">
                <span className="text-muted">{item.label}:</span>
                <span className="fw-medium">
                  {item.hasValue ? (
                    item.badgeColor ? (
                      <Badge color={item.badgeColor}>{item.value}</Badge>
                    ) : (
                      item.value
                    )
                  ) : (
                    <Badge color="light" className="text-muted">Not Available</Badge>
                  )}
                </span>
              </div>
            ))
          )}
        </div>
      </CardBody>
    </Card>
  )
}

export default AdditionalInfoCard